import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import ConsoleLogger from "../Utils/ConsoleLogger";
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';
import ReCAPTCHA from "react-google-recaptcha";
import Footer from "./Footer";


let config = require('../Config/appConfig.json');
let api_credentials_url = config.GET_API_CREDENTIALS;
let URL_SEND_EMAIL = config.SEND_MAIL_URL;
let KEY_SENDING_MAIL = config.KEY_SENDING_MAIL;
const context = "Description.js";
const NOTIFICATION_TYPE_ERROR = "error";
const NOTIFICATION_TYPE_SUCCESS = "success";
let self = null;
@inject("appStore")
@observer
class Description extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isCaptchaverified: false,
            name: "",
            email: "",
            subject: "",
            phone: "",
            message: ""
        };
    }

    componentWillMount = () => {
        self = this;
    }

    onNameChange = (event) => {
        this.setState({
            name: event.target.value
        })
    }

    onEmailChange = (event) => {
        this.setState({
            email: event.target.value
        })
    }

    onSubjectChange = (event) => {
        this.setState({
            subject: event.target.value
        })
    }

    onPhoneChange = (event) => {
        this.setState({
            phone: event.target.value
        })
    }

    onMessageChange = (event) => {
        this.setState({
            message: event.target.value
        })
    }

    onReCaptchaChange = (value) => {
        //console.log("ReCaptcha Value => ", value)
        if (value.length > 0) {
            //console.log("Verified")
            this.setState({
                isCaptchaverified: true
            })
        }
    }

    submitForm = () => {
        console.log("Submit Called");
        var isCaptchaverified = this.state.isCaptchaverified;
        var name = this.state.name;
        var email = this.state.email;
        var subject = this.state.subject;
        var phone = this.state.phone;
        var message = this.state.message;
        if (isCaptchaverified) {
            console.log("Name  => " + name);
            console.log("email  => " + email);
            console.log("subject  => " + subject);
            console.log("phone  => " + phone);
            console.log("message  => " + message);

            if (name == null || name == "" || name == undefined || name.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Name field is invalid");
            } else if (email == null || email == "" || email == undefined || email.length < 6 || email == "email@client.com" || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Email field is invalid");
            } else if (subject == null || subject == "" || subject == undefined || subject.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Subject field is invalid");
            } else if (phone == null || phone == "" || phone == undefined || phone.length < 10) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Phone field is invalid");
            } else if (message == null || message == "" || message == undefined || message.length < 10) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Message field is invalid");
            } else {
                var txt = "Name : ".concat(name);
                txt = txt.concat("\nEmail Id : ", email);
                txt = txt.concat("\nMobile : ", phone);
                txt = txt.concat("\nSubject : ", subject);
                txt = txt.concat("\nMessage: ", message);
                this.sendMail(txt, subject)
            }

        } else {
            this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Please verify the captcha")
        }
    }

    addNotifiation = (type, message) => {
        window.sendNotification(type, message)
    }

    sendMail = (text, subject) => {
        var info = {
            secret_key: KEY_SENDING_MAIL,
            subject: subject,
            text: text
        };
        fetch(URL_SEND_EMAIL, {
            method: 'POST',
            //headers: JSON.stringify(headers),
            body: JSON.stringify(info)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (responseJson) {
                try {
                    var resJson = JSON.stringify(responseJson);
                    console.log("Success => " + resJson)
                    self.addNotifiation(NOTIFICATION_TYPE_SUCCESS, "Message sent successfully");
                } catch (e) {
                    console.log("1 Error => " + e)
                }
            })
            .catch(function (error) {
                console.log("2 Error => " + error)
            });
    }

    componentDidMount = () => {
        //console.log("PROPS", this.props);
    }
    render() {

        return (
            <div>
                <section className="pt-120 pb-120">
                    <div className="container">
                    <div className="section-title">
                                    <h3>Features</h3>
                                    <h2>Hard to believe in...</h2>
                                    {/* <p>We basically catter office commute in form of Hexa H2O and aslo school as Hexa Skool.</p> */}
                                </div>
                        <div className="row">
                            
                            <div className="col-lg-4" style={{ textAlign: "right" }}>
                                
                                <div className="contact-info">
                                    <div className="row">
                                        <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">

                                            <div className="media-body">
                                                <h4>Tracking</h4>
                                                <p>Now be with your child throughout the journey from-to school.</p>
                                            </div>
                                            <div className="image" style={{ marginRight: 0, marginLeft: 30 }}> <img src="assets/custom_icons/features/route.png" className="contact-form-icons" alt="" /> </div>
                                        </div>
                                        <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">

                                            <div className="media-body">
                                                <h4>Alerts</h4>
                                                <p>Push and SMS notification when every your child gets-in or gets-out from the pool car.</p>
                                            </div>
                                            <div className="image" style={{ marginRight: 0, marginLeft: 30 }}> <img src="assets/custom_icons/features/smartphone.png" className="contact-form-icons" alt="" /> </div>
                                        </div>
                                    
                                        <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">

                                            <div className="media-body">
                                                <h4>Hassle-free</h4>
                                                <p>Your child would not be going to school, notify the driver the previous night.</p>
                                            </div>
                                            <div className="image" style={{ marginRight: 0, marginLeft: 30 }}> <img src="assets/custom_icons/features/cocktail.png" className="contact-form-icons" alt="" style={{ height: 50, width: 50 }} /> </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 d-none d-lg-block" style={{textAlign: "center"}}>
                                <img src="assets/img/custom_icons/FrontScreen.jpg" style={{ height: '100%', width: '50%',  alignContent:'center'}} />
                            </div>
                            <div className="col-lg-4">
                                <div className="contact-info">
                                    <div className="row">
                                        <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">
                                            <div className="image"> <img src="assets/custom_icons/features/list.png" className="contact-form-icons" alt="" /> </div>
                                            <div className="media-body">
                                                <h4>Unique Feature</h4>
                                                <p>You can mark your child absent if he/she is not able to go to school.</p>
                                            </div>
                                        </div>
                                      
                                        <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">
                                            <div className="image"> <img src="assets/custom_icons/features/security.png" className="contact-form-icons" alt="" style={{ height: 50, width: 50 }} /> </div>
                                            <div className="media-body">
                                                <h4>Safety First</h4>
                                                <p>A simple way to keep a track while being at office. </p>
                                            </div>
                                        </div>
                                          <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">
                                            <div className="image"> <img src="assets/custom_icons/features/cctv.png" className="contact-form-icons" alt="" style={{ height: 50, width: 50 }} /> </div>
                                            <div className="media-body">
                                                <h4>CCTV Camera</h4>
                                                <p>Camera inside car pool helps you to keep an eye as well.</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        );
    }
}

export default withRouter(Description);


// WEBPACK FOOTER //
// ./src/Pages/Description.js